const DownloadIcon = ({ backgroundFill, strokeColor, strokeWidth, width }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width={width}>
      <path
        d="M5.5,8.5l3,3M8.5,11.5l3-3M8.5,11.5v-6M16,8.5c0,4.14-3.36,7.5-7.5,7.5S1,12.64,1,8.5,4.36,1,8.5,1s7.5,3.36,7.5,7.5Z"
        fill={backgroundFill}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadIcon;
